import IconButton from '@/global/components/Button/IconButton'
import Menu from '@/global/components/MenuV2'
import { permissoes, Supervisor } from '@/service/api'
import { CategoriaEnum } from '@acme/auth'
import { Grid } from '@mui/material'
import { FormField, FormFieldSelect } from 'global/components/Form'
import { XIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

interface IProps {
    edit?: boolean
}

export const SupervisorForm: React.FC<IProps> = ({ edit }) => {
    const { watch, setValue } = useFormContext<Supervisor>()
    const categoriaSupervisor = watch('Usuario.categoriaId')
    const perfil = watch('Usuario.perfilPermissaoId')

    const { data = [] } = permissoes.useFetch()

    return (
        <Grid container columnSpacing={3} rowSpacing={1}>
            <Grid item xs={12}>
                <FormField name="nome" label="Nome do supervisor" required />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="cpf"
                    label="CPF"
                    placeholder="000.000.000-00"
                    options={{
                        blocks: [3, 3, 3, 2],
                        delimiters: ['.', '.', '-'],
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    placeholder="Selecione uma categoria"
                    name="Usuario.categoriaId"
                    label="Categoria"
                    select
                    required
                >
                    <Menu.Item value={CategoriaEnum.Cliente}>
                        Administrador
                    </Menu.Item>
                    <Menu.Item value={CategoriaEnum.Supervisor}>
                        Supervisor
                    </Menu.Item>
                </FormField>
            </Grid>
            <Grid item xs={7}>
                <FormField
                    name="Usuario.email"
                    label="Email"
                    required
                    autoComplete="new-email"
                />
            </Grid>
            <Grid item xs={5}>
                <FormField
                    name="Usuario.password"
                    label="Senha"
                    hiddenPassword
                    autoComplete="new-password"
                    {...(edit
                        ? {
                              placeholder: '(inalterada)',
                          }
                        : {
                              required: true,
                          })}
                />
            </Grid>
            {categoriaSupervisor == CategoriaEnum.Supervisor && (
                <Grid item xs={12}>
                    <FormFieldSelect
                        name="Usuario.perfilPermissaoId"
                        label="Perfil de permissão"
                        options={data.map(option => ({
                            label: option.nome,
                            value: option.id.toString(),
                        }))}
                        endAdornment={
                            perfil ? (
                                <IconButton
                                    className="absolute top-2 right-9"
                                    title="Remover perfil"
                                >
                                    <XIcon
                                        onClick={() =>
                                            setValue(
                                                'Usuario.perfilPermissaoId',
                                                null,
                                            )
                                        }
                                    />
                                </IconButton>
                            ) : null
                        }
                    />
                </Grid>
            )}
        </Grid>
    )
}
